import { baseConfig, RuntimeConfig } from 'config/config.types';

export const config: RuntimeConfig = {
  ...baseConfig,
  env: 'pcm-tst50',
  gravityEnabledByDefault: true,
};
